// extracted by mini-css-extract-plugin
export default {"warning":"NoEmailSubscriptionWarning_warning__IwPFC","contactButton":"NoEmailSubscriptionWarning_contactButton__SNy6p"};